/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendCreditVariantDto } from '../../models/backend-credit-variant-dto';
import { BackendCreditVariantRequestDto } from '../../models/backend-credit-variant-request-dto';

export interface FinancingSourcesCreditsVariantsCreate$FormData$Params {
  body: BackendCreditVariantRequestDto;
}

export function financingSourcesCreditsVariantsCreate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: FinancingSourcesCreditsVariantsCreate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendCreditVariantDto>> {
  const rb = new RequestBuilder(rootUrl, financingSourcesCreditsVariantsCreate$FormData.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendCreditVariantDto>;
    }),
  );
}

financingSourcesCreditsVariantsCreate$FormData.PATH = '/api/financing_sources/credits_variants/';
